import { CountryType } from '../../../../types/CountryType'
import { Employee } from '../../../../types/Employee'
import { IdCard } from './components/IdCard'
import { PersonalInformation } from './components/PersonalInformation'
import { ResidencePermit } from './components/ResidencePermit'
import { WorkPermit } from './components/WorkPermit'

interface Props {
  countries: CountryType[]
  employee: Employee
}

export const FormContent = ({ countries, employee }: Props) => {
  return (
    <>
      <PersonalInformation countries={countries} />
      <IdCard countries={countries} employee={employee} />
      <ResidencePermit countries={countries} employee={employee} />
      <WorkPermit countries={countries} employee={employee} />
    </>
  )
}
